import { encryptedData } from ".";
import { UPDATE_USER_CONSENT_STATUS } from "../Config";
import { encrypt } from "./crypto";
import sendRequest from "./sendRequest";

export const userConsentStatus = async (payload ,src) => {
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload)); // Encrypt the payload if needed
  
      // console.log("Payload: ", payload);
  
      const response = await sendRequest(
        "/" + src + UPDATE_USER_CONSENT_STATUS,
        formData
      );
  
      // console.log("API Response: ", response);
  
      // Handle the response
      if (response?.response?.Success) {
        // console.log("Consent status updated successfully");
        return response.response; // Return the response for further processing
      } 
      else {
        console.error("Success false:", response?.response?.Message);
        throw new Error(response?.response?.Message || "Failed to update consent status");
      }
    } catch (error) {
      console.error("Error:", error);
      throw error; // Re-throw the error to be handled by the caller
    }
  };
  